// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__7NGI9","pagination__btns":"pagination_pagination__btns__ePivu","pagination__stats":"pagination_pagination__stats__dMJpi"};